import { DiscountVoucher } from '../models'
import { getTransformedDate } from './date-helpers'

export const getDiscountVouchersFiltered = (
  text: string, bigList: DiscountVoucher[]
) : DiscountVoucher[] => {
  let list = bigList

  if (text) {
    const textValue = text.toLowerCase()
    list = list.filter(discountVoucher => {
      return (
        discountVoucher?.code?.toLowerCase()?.includes(textValue) ||
        discountVoucher?.email?.toLowerCase()?.includes(textValue) ||
        getTransformedDate(discountVoucher?.created)?.toLowerCase()?.includes(textValue) ||
        getTransformedDate(discountVoucher?.expiration_date)?.toLowerCase()?.includes(textValue)
      )
    })
  }
  return list
}
